<table class="config-container config-table">
	<thead>
		<tr>
			<th colspan="3" class="table-heading">{{TR "Parameter"}}</th>
		</tr>
		<tr colspan="3" class="blank-row"></tr>
		<tr class="table-column-heading">
			<th></th>
			<th colspan="2">{{TR "Außentemperatur"}}</th>
			<th colspan="2">{{currentName}}</th>
		</tr>
	</thead>
	<tbody>
		{{#each config.values}}
		<tr>
			<th class="table-column-heading">P{{CALCULATE @index '+' 1}}</th>
			<td>
				<input id="outdoorTemperature{{@index}}" class="form-control input-sm js-edit-value text-right"
					type="number"  value="{{SHIFT_DECIMAL 1 this.[0]}}">
			</td>
			<td class="decoration">
				<span class="input-group-addon b-0"> °C </span>
			</td>
			<td>
				<input id="js-input{{@index}}" class="input-sm js-edit-value form-control text-right"
					type="number" value="{{SHIFT_DECIMAL 1 this.[1]}}">
			</td>
			<td class="decoration">
				<span class="input-group-addon b-0"> °C </span>
			</td>
		</tr>
		{{/each}}
	</tbody>
</table>

